import { Layers, Eye } from "lucide-react";

export default function DifferenceSection() {
  return (
    <section
      id="difference"
      className="relative py-16 md:py-32 bg-[#0F1115]"
      data-testid="difference-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Left Content */}
          <div className="text-center md:text-left">
            <span className="inline-block px-4 py-1 text-xs font-mono tracking-widest uppercase text-[#F59E0B] bg-[#0E3A46] border border-[#F59E0B]/20 rounded-sm mb-6">
              A Diferença
            </span>

            <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#E5E7EB] mb-4">
              Experiência constrói.
            </h2>
            <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#F59E0B] mb-8">
              Estrutura sustenta.
            </h2>

            <div className="space-y-6 text-[#9CA3AF]">
              <p className="text-base md:text-lg leading-relaxed">
                O KpAction não substitui sua visão.
                <br />
                <span className="text-[#E5E7EB]">
                  Ele amplia sua capacidade de antecipação.
                </span>
              </p>
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <div className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-8 md:p-10">
              <div className="flex items-center justify-center gap-8">
                <div className="text-center">
                  <div className="w-20 h-20 flex items-center justify-center bg-[#0E3A46] rounded-sm mb-4 mx-auto">
                    <Layers className="h-10 w-10 text-[#9CA3AF]" />
                  </div>
                  <p className="text-sm font-mono tracking-widest uppercase text-[#6B7280]">
                    Experiência
                  </p>
                  <p className="text-2xl font-heading font-bold text-[#E5E7EB] mt-2">
                    Constrói
                  </p>
                </div>

                <div className="text-4xl text-[#2A2F38]">+</div>

                <div className="text-center">
                  <div className="w-20 h-20 flex items-center justify-center bg-[#F59E0B]/10 border border-[#F59E0B]/30 rounded-sm mb-4 mx-auto">
                    <Eye className="h-10 w-10 text-[#F59E0B]" />
                  </div>
                  <p className="text-sm font-mono tracking-widest uppercase text-[#F59E0B]">
                    Estrutura
                  </p>
                  <p className="text-2xl font-heading font-bold text-[#F59E0B] mt-2">
                    Sustenta
                  </p>
                </div>
              </div>

              {/* Decorative Line */}
              <div className="mt-8 pt-8 border-t border-[#2A2F38]">
                <p className="text-center text-sm text-[#6B7280] font-mono tracking-wider">
                  CRESCIMENTO × SUSTENTABILIDADE = SUCESSO
                </p>
              </div>
            </div>

            {/* Tech Corners */}
            <div className="absolute -top-2 -left-2 w-6 h-6 border-t-2 border-l-2 border-[#F59E0B]" />
            <div className="absolute -bottom-2 -right-2 w-6 h-6 border-b-2 border-r-2 border-[#F59E0B]" />
          </div>
        </div>
      </div>
    </section>
  );
}
